import {
  IonContent,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
} from "@ionic/react";
import React from "react";
import { Redirect, Route, useLocation } from "react-router-dom";

/**
 * Tabs component
 * @param {{
 *   basePath: string,
 *   tabs: {
 *     label: string,
 *     path: string,
 *     Component: React.ComponentType
 *   }[]
 * }} props
 */
const Tabs = ({ basePath, tabs }) => {
  const defaultTab = tabs[0]?.path;
  const location = useLocation();

  return (
    <IonTabs className="tabs">
      <IonRouterOutlet>
        {/* Redirect */}
        {/* <Route
          exact
          path={basePath}
          render={() => <Redirect to={`${basePath}/${defaultTab}`} />}
        /> */}

        {tabs.map((tab) => (
          <Route
            key={tab.label}
            exact
            path={`${basePath}/${tab.path}`}
            render={() => (
              <IonContent>
                <tab.Component />
              </IonContent>
            )}
          />
        ))}
      </IonRouterOutlet>

      <IonTabBar slot="top" className="tabs-container">
        {tabs.map((tab) => (
          <IonTabButton
            // className="poetsen"
            key={tab.label}
            tab={`tab-${tab.path}`}
            href={`${basePath}/${tab.path}`}
            // selected={location.pathname === `${basePath}/${tab.path}`}
            selected={
              tab.path === ""
                ? location.pathname === basePath ||
                  location.pathname === `${basePath}/`
                : location.pathname.startsWith(`${basePath}/${tab.path}`)
            }
          >
            <IonLabel>{tab.label}</IonLabel>
          </IonTabButton>
        ))}
      </IonTabBar>
    </IonTabs>
  );
};

export default Tabs;
